import { render, staticRenderFns } from "./DistributionsRules.vue?vue&type=template&id=48e8238e&"
import script from "./DistributionsRules.vue?vue&type=script&lang=js&"
export * from "./DistributionsRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports